import React from 'react';
import {Redirect} from "react-router-dom";

const Settings = props => {
    return <Redirect to="/admin/settings/user-roles"/>
}

export default Settings;
